/**
 * Announcement layout config. MUST stay in sync with AnnouncementLayout (Ruby).
 * Used by community_composer_modal_controller.
 */
export const AnnouncementConfig = {
  MAX_LINES: 6,
  MAX_CHARS: 120,

  LARGE_MAX_LINES: 2,
  LARGE_MAX_CHARS: 50,
  MEDIUM_MAX_LINES: 4,
  MEDIUM_MAX_CHARS: 90,

  FONT_SIZES: { Large: 56, Medium: 48, Small: 40 },

  countLines(text) {
    if (!text || !text.length) return 0;
    return text.split("\n").length;
  },

  countChars(text) {
    if (!text || !text.length) return 0;
    return text.replace(/\s+$/, "").length;
  },

  isHardValid(lines, chars) {
    return lines <= this.MAX_LINES && chars <= this.MAX_CHARS;
  },

  selectFontBracket(lines, chars) {
    if (!this.isHardValid(lines, chars)) return "Small";
    if (lines <= this.LARGE_MAX_LINES && chars <= this.LARGE_MAX_CHARS) return "Large";
    if (lines <= this.MEDIUM_MAX_LINES && chars <= this.MEDIUM_MAX_CHARS) return "Medium";
    return "Small";
  },

  compute(text) {
    const lines = this.countLines(text);
    const chars = this.countChars(text);
    const hardValid = this.isHardValid(lines, chars);
    const bracket = this.selectFontBracket(lines, chars);
    return {
      valid: hardValid,
      lines,
      chars,
      bracket,
      fontSize: this.FONT_SIZES[bracket],
    };
  },

  limitHint() {
    return `Announcement is limited to ${this.MAX_LINES} lines and ${this.MAX_CHARS} characters.`;
  },
};
